export default __webpack_public_path__ + "static/media/SB.69d630de.svg";